export function initMainPage() {
  const modalWindow = document.querySelector('.modal-window')

  if (modalWindow) {
    modalWindow.style.display = 'none'
  }

  const pxToVw = value => {
    if (window.innerWidth <= 340) {
      return `${(value / 340) * 100}vw`
    }

    if (window.innerWidth <= 680) {
      return `${(value / 680) * 100}vw`
    }

    if (window.innerWidth <= 1000) {
      return `${(value / 1000) * 100}vw`
    }

    return `${(value / 1440) * 100}vw`
  }

  const marginRightVW = value => {
    const layoutWidth = window.outerWidth <= 680 ? 680 : 1440
    const percentage = (value / layoutWidth) * 100

    return (window.outerWidth / 100) * percentage
  }

  /*
   * Эти функции оставлены из legacy-кода.
   * Удалите строки ниже, если они нигде не используются.
   */
  void pxToVw
  void marginRightVW

  const handleReactionClick = event => {
    const target = event.target.closest(
      '.record-card__reaction-button, .js-reaction-button',
    )

    if (!target) {
      return
    }

    const reactions = target.closest('.record-card__reactions, .js-reactions')

    if (!reactions) {
      return
    }

    reactions.querySelectorAll('button').forEach(button => {
      button.classList.remove('active')
    })

    target.classList.add('active')
  }

  document.addEventListener('click', handleReactionClick)

  const firstScreenBtn = document.querySelector('.first-screen-block_btn')

  const maps = document.querySelector('.maps')

  const showButton = document.querySelector('.maps-navs__show-wrapper')

  const largerBlockBtn = document.querySelector('.larger-block__btn')

  const checkButton = () => {
    if (!firstScreenBtn || !maps || !showButton) {
      return
    }

    if (window.innerWidth >= 1025) {
      showButton.classList.remove('visible')
      return
    }

    const btnRect = firstScreenBtn.getBoundingClientRect()
    const mapsRect = maps.getBoundingClientRect()

    // Первый экран полностью скрыт.
    const firstScreenHidden = btnRect.bottom <= 0

    // Блок maps ещё не прокручен полностью.
    const mapsNotPassed = mapsRect.bottom > 0

    // Дошли до блока с кнопками.
    const largerBtnsReached =
      Boolean(largerBlockBtn) &&
      largerBlockBtn.getBoundingClientRect().top <= window.innerHeight

    showButton.classList.toggle(
      'visible',
      firstScreenHidden && mapsNotPassed && !largerBtnsReached,
    )
  }

  window.addEventListener('scroll', checkButton, {
    passive: true,
  })

  window.addEventListener('resize', checkButton)

  checkButton()

  const successIcon = `
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M8.99978 18C8.99878 18 8.99778 18 8.99578 18C8.72878 17.999 8.47477 17.892 8.28777 17.702L4.28778 13.64C3.89978 13.246 3.90478 12.613 4.29878 12.226C4.69278 11.839 5.32478 11.843 5.71278 12.237L9.00577 15.581L18.2938 6.29398C18.6848 5.90298 19.3168 5.90298 19.7078 6.29398C20.0988 6.68398 20.0988 7.31798 19.7078 7.70798L9.70777 17.708C9.51977 17.895 9.26478 18 8.99978 18Z"
        fill="#19AA1E"
      />
    </svg>
  `

  const defaultCopyButtonContent = `
    <svg
      class="copy_button__icon record-card__copy-icon"
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path
        d="M21.6553 10.0703V18.8203C21.6553 20.5703 20.7803 21.4453 19.0303 21.4453H10.2803C8.53027 21.4453 7.65527 20.5703 7.65527 18.8203V10.0703C7.65527 8.32031 8.53027 7.44531 10.2803 7.44531H19.0303C20.7803 7.44531 21.6553 8.32031 21.6553 10.0703ZM16.4053 3.44531C16.4053 3.03131 16.0693 2.69531 15.6553 2.69531H6.28027C4.10327 2.69531 2.90527 3.89331 2.90527 6.07031V15.4453C2.90527 15.8593 3.24127 16.1953 3.65527 16.1953C4.06927 16.1953 4.40527 15.8593 4.40527 15.4453V6.07031C4.40527 4.73831 4.94827 4.19531 6.28027 4.19531H15.6553C16.0693 4.19531 16.4053 3.85931 16.4053 3.44531Z"
        fill="#1A1A1A"
        fill-opacity="0.4"
      />
    </svg>

    <span class="copy_button__text record-card__copy-text">
      Скопировать ссылку на рекорд
    </span>
  `

  const successCopyButtonContent = `
    ${successIcon}

    <span class="copy_button__text record-card__copy-text">
      Ссылка на рекорд скопирована
    </span>
  `

  const copyTimers = new Map()

  const resetCopyButton = copyButton => {
    copyButton.classList.remove('is-copied')
    copyButton.innerHTML = defaultCopyButtonContent
  }

  const copyText = async text => {
    if (navigator.clipboard?.writeText) {
      try {
        await navigator.clipboard.writeText(text)
        return
      } catch {
        // На HTTP Clipboard API может быть недоступен или заблокирован.
      }
    }

    const textarea = document.createElement('textarea')
    const { activeElement } = document

    textarea.value = text
    textarea.setAttribute('readonly', '')
    textarea.style.position = 'fixed'
    textarea.style.left = '-9999px'
    textarea.style.opacity = '0'
    document.body.append(textarea)
    textarea.select()
    textarea.setSelectionRange(0, textarea.value.length)

    let isCopied = false

    try {
      isCopied = document.execCommand('copy')
    } finally {
      textarea.remove()

      if (activeElement instanceof HTMLElement) {
        activeElement.focus()
      }
    }

    if (!isCopied) {
      throw new Error('Браузер не разрешил скопировать ссылку')
    }
  }

  const handleCopyClick = async event => {
    const copyButton = event.target.closest('.record-card__copy-button')

    if (!copyButton) {
      return
    }

    const article = copyButton.closest('article')

    const { id: sectionId } = article

    const url = new URL(window.location.href)

    url.hash = sectionId

    try {
      await copyText(url.toString())

      const previousTimer = copyTimers.get(copyButton)

      if (previousTimer) {
        window.clearTimeout(previousTimer)
      }

      copyButton.classList.add('is-copied')
      copyButton.innerHTML = successCopyButtonContent

      const timer = window.setTimeout(() => {
        resetCopyButton(copyButton)
        copyTimers.delete(copyButton)
      }, 3000)

      copyTimers.set(copyButton, timer)
    } catch (error) {
      console.error('Ошибка копирования:', error)
    }
  }

  document.addEventListener('click', handleCopyClick)

  return () => {
    document.removeEventListener('click', handleReactionClick)

    document.removeEventListener('click', handleCopyClick)

    window.removeEventListener('scroll', checkButton)
    window.removeEventListener('resize', checkButton)

    copyTimers.forEach(timer => {
      window.clearTimeout(timer)
    })

    copyTimers.clear()
  }
}
